var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgF(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 119.5 28.8",
    style: {
      enableBackground: "new 0 0 119.5 28.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2,28.3H0v-28h17.7v4.3H5.2v7.6H15v4.2H5.2V28.3z M43.1,28.3h-5.3l-4.3-11.5h-7.1v11.5h-5v-28h12.1c3.4,0,5.9,0.8,7.4,2.3 s2.4,3.5,2.4,5.9c0,3.6-1.7,6.1-5,7.4L43.1,28.3z M26.4,12.8h6.3c1.8,0,3.2-0.4,4.1-1.1s1.3-1.8,1.3-3.2c0-1.2-0.4-2.2-1.3-3 s-2.1-1.1-3.7-1.1h-6.7C26.4,4.4,26.4,12.8,26.4,12.8z M58.2,28.8c-3.7,0-6.6-1.4-8.7-4.2s-3.1-6.2-3.1-10.3s1.1-7.5,3.3-10.2 S54.8,0,58.4,0C62,0,64.9,1.4,67,4.1s3.2,6.2,3.2,10.3c0,4.3-1.1,7.8-3.3,10.5S61.9,28.8,58.2,28.8z M58.3,24.7 c1.8,0,3.4-0.8,4.6-2.3c1.2-1.5,1.9-4.2,1.9-8.2c0-3.2-0.5-5.7-1.6-7.6s-2.7-2.7-4.8-2.7c-4.3,0-6.5,3.5-6.5,10.4 c0,3.4,0.6,5.9,1.7,7.7S56.2,24.7,58.3,24.7z M96.1,28.3h-4.9L80.6,10.5c-0.2-0.3-0.4-0.7-0.8-1.3c-0.2-0.4-0.4-0.8-0.8-1.4v20.5 h-4.1v-28h5.6l9.8,16.5c0.1,0.1,0.7,1.1,1.8,3V0.3h4V28.3z M112,28.3h-5.4V4.7h-7.4V0.3h20.3v4.3h-7.4L112,28.3L112,28.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF);
export default __webpack_public_path__ + "static/media/F.085575071caaf1d37c89a3d7f40ad0d1.svg";
export { ForwardRef as ReactComponent };